import { DatePipe } from '@angular/common';
import { AfterViewChecked, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { WizardComponent } from 'angular-archwizard';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { concat, Observable, of, Subscription } from 'rxjs';
import { catchError, first, tap } from 'rxjs/operators';
import { CampoSolicitud } from '../../core/model/campo-solicitud';
import { ComboNgSelect } from '../../core/model/combos';
import { ContadorContenidos, DetalleSolicitud, TableContentInfo, DataReturnsSelected, DevolucionSinPrestamo } from '../../core/model/detalle-solicitud';
import { Direcciones } from '../../core/model/direcciones';
import { FileType } from '../../core/model/file';
import { FiltroDevolucion } from '../../core/model/filtro-devolucion';
import { Instruccion, InstruccionRequest } from '../../core/model/instrucciones';
import {
  Expedientes, InventoryIdenty, IResultadoDocument, TIPO_DOCUMENTAL,
  TypeShoppingCart, ContenedorDetail
} from '../../core/model/inventories';
import { AzDetail } from '../../core/model/inventory-detail/az-detail';
import { FileData } from '../../core/model/massive-load-result';
import { Page } from '../../core/model/page';
import { ResizedEvent } from '../../core/model/resized-event';
import { ServiceConfig } from '../../core/model/service-config';
import { CampoValor, ContenidoInventariado, ContenidoNoInventariado, Solicitud } from '../../core/model/solicitud';
import { SelectValue, TemplateField } from '../../core/model/template-field';
import { EntregaServicio, TratamientoServicio, MotivosPeticion } from '../../core/model/tipo-servicio';
import { UnidadSolicitud } from '../../core/model/unidad-solicitud';
import { Userprofile } from '../../core/model/users';
import { ValorCampoSerie } from '../../core/model/valor-campo-serie';
import { AlbaranService } from '../../core/services/albaran.service';
import { AuthenticationService } from '../../core/services/authentication.service';
import { ContenidosService } from '../../core/services/contenidos.service';
import { DetalleService } from '../../core/services/Detalle/detalle.service';
import { DireccionesService } from '../../core/services/direcciones.service';
import { FileManagerService } from '../../core/services/files/file-manager.service';
import { InstruccionesService } from '../../core/services/instrucciones.service';
import { InventariosService } from '../../core/services/inventarios.service';
import { ObservacionesSolicitudService } from '../../core/services/observaciones-solicitud.service';
import { ParametrosServicioService } from '../../core/services/parametros-servicio.service';
import { SeriesService } from '../../core/services/series.service';
import { ServiceConfigService } from '../../core/services/service-config.service';
import { ShoppingElementsService } from '../../core/services/shopping-elements.service';
import { SolicitudServicioService } from '../../core/services/solicitud-servicio.service';
import { TipoServicioService } from '../../core/services/tipo-servicio.service';
import { UsersService } from '../../core/services/users.service';
import { UtilitiesService } from '../../core/services/Utility/utilities.service';
import { ModalShowTextComponent } from '../../utils/modal-show-text/modal-show-text.component';
import { DireccionSolicitudesComponent } from '../direccion-solicitudes/direccion-solicitudes.component';
import { FormularioPlantillaComponent } from '../formulario-plantilla/formulario-plantilla.component';

@Component({
  selector: 'app-solicitud-servicio',
  templateUrl: './solicitud-servicio.component.html',
  styleUrls: ['./solicitud-servicio.component.css']
})
export class SolicitudServicioComponent implements OnInit, AfterViewChecked {
  @ViewChild('plantilla') plantilla: FormularioPlantillaComponent;
  @ViewChild('wizard') wizard: WizardComponent;
  @ViewChild('tableContenidos') tableContenidos: DatatableComponent;
  @ViewChild('tableFilesMassiveLoad') tableFilesMassiveLoad: DatatableComponent;
  @ViewChild('tableContenidosValidacion') tableContenidosValidacion: DatatableComponent;
  @ViewChild('tableContenidosFileMassiveLoad') tableContenidosFileMassiveLoad: DatatableComponent;
  @ViewChild('tableDevolucion') tableDevolucion: DatatableComponent;
  @ViewChild('tablaErroresEnvio') tablaErroresEnvio: DatatableComponent;
  isPrestamoInventario = false;

  Boxtype = 'box-primary';
  Title: string;
  Description: string;
  Padre: string;
  Hijo: string;

  isSupervisor: boolean;
  isDocoutUser: boolean;
  direccionSeleccionada: Direcciones;
  direcciones: Direcciones[];
  direccionTemplate: BsModalRef;
  tiposServicio: TratamientoServicio[];
  tiposTratamiento: string[] = [];
  tiposEnvio: string[] = [];
  tiposEntrega: EntregaServicio[] = [];
  cargaMasiva = false;

  public campos: TemplateField[] = undefined;
  solicitud = new Solicitud();
  unidades: any[];
  unidadesAux: any[];

  unidadesPorCargaMasivaEnDevolucionByData: any[] = [];

  tipoEntrega: string;
  tratamiento: string;
  envio: string;
  user: Userprofile;
  tableVisible = false;
  solicitudesIds: any[] = undefined;
  observaciones: string;
  servicioActual: string;
  configServicio: ServiceConfig;
  public bsConfig: BsDatepickerConfig;
  loading = false;
  errorCodes: string[] = [];
  errorsContenidos = [];
  errorsFicheros = [];
  errorsToShow: { id: number, errorCode: string, errorElement: any }[] = [];
  reintentado = false;
  clienteSeleccionado: number;
  usuarioSeleccionado: number;
  campoEdicion: TemplateField;
  registroEdicion: any;
  instruccion: string;
  stepTitle: string;
  camposSimples: TemplateField[];
  templateId: number;

  observablesFicheros: Map<number, Observable<any>> = new Map();

  filesMassiveLoadAdded: FileData[] = [];
  filesAttachRequest: FileData[] = [];
  carouselFiles: { name: string, guid: string, date: string, fileData: any }[] = [];
  contadorUnidades = 0;
  unidadAEditar: UnidadSolicitud;
  detailVisible = false;
  clientIdSelected = 0;

  cargandoDevoluciones = false;

  inventoryCartInfo: { clientId: number, identidades: InventoryIdenty[] };
  page = new Page();

  nextStepButtonActive = false;
  defaultWizardStep = 0;
  isFirstStep = false;

  hasInitialData: boolean = undefined;

  hasAnyRecord: boolean;
  hasColumnRelationRequest = false;

  contadorDevoluciones: ContadorContenidos;
  rowsContenidosNoInventariados: TableContentInfo[];
  rowsContenidosExpedientes: TableContentInfo[];
  rowsContenidosContenedores: TableContentInfo[];
  rowsContenidosAZs: TableContentInfo[];
  hasDevoluciones = false;

  rowsDevolucionesSelected: TableContentInfo[] = [];

  authorizationTypeServiceMessage: string = undefined;
  authorizationTypeDeliveryMessage: string = undefined;

  motivosPeticion: MotivosPeticion[] = undefined;
  motivoSelect: MotivosPeticion;
  cadenaOtrosMotivos: string = undefined;

  dataSelected: DataReturnsSelected = { needDataToShowData: false };


  emailForm = this.fb.group({
    email: [{ value: '', disabled: this.authService.isSsoAuthentication() }, [Validators.required, Validators.email, Validators.maxLength(50)]],
  });
  clientHasInitialDataEvent: Subscription;

  private filesInExecution: Map<number, FileData> = undefined;

  filtroDevolucion: FiltroDevolucion;
  returnWithoutLoan: DevolucionSinPrestamo;

  get email() { return this.emailForm.get('email'); }


  idSolicitudDevolucion: number;
  clientsDevolucionSolicitud: ComboNgSelect[];
  clientDevolucionSolicitud: number;
  usersDevolucionSolicitud: ComboNgSelect[];
  userDevolucionSolicitud: number;
  departamentosDevolucionSolicitud: ComboNgSelect[];
  departamentoDevolucionSolicitud: number;
  seriesDevolucionSolicitud: ComboNgSelect[];

  maxContenidos?: number;
  hasAddMoreUnits = true;

  isFormularioPlantillaValid = false;
  isSsoAuthenticate = false;



  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  constructor(
    public authService: AuthenticationService,
    private translateService: TranslateService,
    private solicitudServicioService: SolicitudServicioService,
    private direccionesService: DireccionesService,
    private modalService: BsModalService,
    private userService: UsersService,
    private cdRef: ChangeDetectorRef,
    private tipoServicioService: TipoServicioService,
    private seriesService: SeriesService,
    private paramsService: ParametrosServicioService,
    private observacionesSolicitudService: ObservacionesSolicitudService,
    private serviceConfigService: ServiceConfigService,
    private albaran: AlbaranService,
    private instruccionesService: InstruccionesService,
    private usersService: UsersService,
    private toastr: ToastrService,
    private activatedRoute: ActivatedRoute,
    private utilservice: UtilitiesService,
    private fb: FormBuilder,
    private fileManagerService: FileManagerService,
    private shoppingElementsService: ShoppingElementsService,
    private contenidosService: ContenidosService,
    private inventoryService: InventariosService,
    private router: Router,
    private datePipe: DatePipe,
    private detalleService: DetalleService
  ) {
    this.isSsoAuthenticate = this.authService.isSsoAuthentication();

    this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
      this.resetComponent();
      this.servicioActual = params.get('servicio');
      const idSolicitudDevolucion = params.get('idSolicitudDevolucion');
      this.idSolicitudDevolucion = idSolicitudDevolucion ? parseInt(idSolicitudDevolucion, 10) : undefined;

      if (this.isDevolucionSolicitud()) {
        this.cargandoDevoluciones = true;
        this.detalleService.getViewDetails(this.idSolicitudDevolucion)
          .pipe(first()).subscribe((contenido: DetalleSolicitud) => {
            this.clientsDevolucionSolicitud = this.createComboNgSelect(contenido.ID_CLIENTE, contenido.NOMBRE_CLIENTE);
            this.clientDevolucionSolicitud = contenido.ID_CLIENTE;
            this.usersDevolucionSolicitud = this.createComboNgSelect(contenido.ID_USUARIO_SOLICITANTE, contenido.NOMBRE_USUARIO_SOLICITANTE);
            this.userDevolucionSolicitud = contenido.ID_USUARIO_SOLICITANTE;
            this.departamentosDevolucionSolicitud = this.createComboNgSelect(contenido.ID_DEPARTAMENTO, contenido.NOMBRE_DEPARTAMENTO);
            this.departamentoDevolucionSolicitud = contenido.ID_DEPARTAMENTO;
            this.seriesDevolucionSolicitud = this.createComboNgSelect(contenido.ID_SERIE, contenido.NOMBRE_SERIE);
            this.solicitud.idSerie = contenido.ID_SERIE;
            this.contadorDevoluciones = contenido.CONTADOR_CONTENIDOS;
          });
      }
      if (this.servicioActual == 'devolucion' || this.servicioActual === 'expurgo') {
        this.dataSelected = { needDataToShowData: true };
        this.detalleService.getCanReturnWithoutLoan()
          .pipe(first()).subscribe((returnWithoutLoan: DevolucionSinPrestamo) => {
            this.returnWithoutLoan = returnWithoutLoan;
          });
      }

      this.isPrestamoInventario = this.servicioActual == 'prestamosInventario';
      if (this.isPrestamoInventario) {
        this.inventoryCartInfo = this.shoppingElementsService.getElementsToLoan();
        if (this.inventoryCartInfo) {
          this.servicioActual = this.inventoryCartInfo.identidades[0].shoppingCart.type == TypeShoppingCart.INSERTION
            ? 'recogida' : 'prestamos';
          this.clientIdSelected = this.inventoryCartInfo.clientId;
          this.page.pageNumber = 0;
          this.page.size = 10;
        }
      }

      this.init();

      if (!this.isPrestamoInventario && this.plantilla) {
        this.plantilla.ngOnInit();
      }
      if (this.wizard !== undefined) {
        this.wizard.navigation.reset();
      }

      this.clientHasInitialDataEvent = this.authService.clientHasInitialData()
        .subscribe(hasInitialData => {
          this.hasInitialData = hasInitialData;
          if (this.hasInitialData && this.isDocoutUser != undefined) {
            this.setIsDocoutUser(this.isDocoutUser);
          } else if (!this.hasInitialData && this.clientHasInitialDataEvent) {
            this.clientHasInitialDataEvent.unsubscribe();
          }
        });
    });
  }

  init() {
    this.SetEnviroment();
    this.InitLanguage();

    this.solicitud = new Solicitud();
    this.solicitud.idTipoServicio = 1;

    this.authService.isDocOutUser()
      .then((isDocUser: boolean) => {
        if (this.hasInitialData) {
          this.setIsDocoutUser(isDocUser);
        }
      });

    this.isSupervisor = this.authService.isSupervisorUser() || this.authService.isAdminUser();
  }

  private setIsDocoutUser(isDocOutUser: boolean) {
    this.isDocoutUser = isDocOutUser;
    let numberInstruccion = 1;
    if (this.isPrestamoInventario && !this.isDocoutUser && !this.isSupervisor) {
      numberInstruccion = 2;
      this.nextStepButtonActive = true;
      this.defaultWizardStep = 1;
    }
    this.getInstruccion(numberInstruccion);
    if (!this.isDocoutUser) {
      this.initializeDataWithoutDocoutUser();
    }
  }

  private createComboNgSelect(id: number, name: string): ComboNgSelect[] {
    const ngSelect = new ComboNgSelect();
    ngSelect.ID = id;
    ngSelect.NOMBRE = name;
    return [ngSelect];
  }

  private initializeDataWithoutDocoutUser() {
    this.configServicio = this.serviceConfigService.getServiceConfig().serviceConfigs.find((c: ServiceConfig) => c.servicio === this.servicioActual);
    this.getRecentUserData();
  }

  private getRecentUserData() {
    this.userService.getUserById(undefined).subscribe((user: Userprofile) => {
      this.user = user;
      this.getDirecciones();
      this.getTiposServicio();
      this.initRadioButtons();
    });
  }

  ngOnInit() {
  }

  private isDevolucionSolicitud() {
    return this.idSolicitudDevolucion && this.servicioActual == 'devolucion';
  }

  initRadioButtons() {
    if (this.tiposTratamiento.length === 1) {
      this.tratamiento = this.tiposTratamiento[0];
    }
    if (this.tiposEntrega.length === 1) {
      this.tratamiento = this.tiposTratamiento[0];
    }
    if (this.tiposEnvio.length === 1) {
      this.tratamiento = this.tiposTratamiento[0];
    }
  }

  InitLanguage() {
    this.translateService.get([this.servicioActual])
      .subscribe(values => { this.TranslateText(values); });

    this.translateService.onLangChange.subscribe(() => {
      this.translateService.get([this.servicioActual])
        .subscribe(values => { this.TranslateText(values); });
    });
  }
  TranslateText(values: any) {
    this.Title = values[this.servicioActual]['cabecera'];
    this.Description = values[this.servicioActual]['descripcion'];
    this.Hijo = values[this.servicioActual]['cabecera'];
  }

  SetEnviroment() {
    this.authService.getClienteName$().subscribe(beadcrumbDad => {
      this.Padre = beadcrumbDad;
    }).unsubscribe();
  }

  addUnidad(nuevaUnidad: UnidadSolicitud) {
    if (!!nuevaUnidad) {
      if (this.maxContenidos == 1 && !this.isDevolucionByData() ) {
        this.resetSolicitudes();
      }

      // if (!this.isDevolucionByData()) {
      nuevaUnidad.id = ++this.contadorUnidades;
      this.solicitud.unidades.push(nuevaUnidad);

      if (this.maxContenidos && this.solicitud.unidades.length >= this.maxContenidos) {
        this.hasAddMoreUnits = false;
      }
      /*} else {
          nuevaUnidad.id = !!this.solicitud.unidades && this.solicitud.unidades.length
                                                      ? Math.max(...this.solicitud.unidades.map(uni => uni.id)) + 1
                                                      : 0;

          if (!nuevaUnidad.isUnitMassiveLoad) {
              this.solicitud.unidades = this.solicitud.unidades.filter(unidad => unidad.isUnitMassiveLoad);
          } else {
              const unidad = this.formatUnidad(nuevaUnidad);
              this.unidadesPorCargaMasivaEnDevolucionByData = [...this.unidadesPorCargaMasivaEnDevolucionByData, unidad];
           }

          this.solicitud.unidades.push(nuevaUnidad);
      // }*/

      this.formatSolicitud(this.solicitud);
    } else if (this.maxContenidos == 1) {
      this.resetSolicitudes();
    }
  }

  private resetSolicitudes() {
    if (!this.isDevolucionByData()) {
      this.unidades = [];
      this.solicitud.unidades = [];
      this.contadorUnidades = 0;
      return;
    }

    this.solicitud.unidades = this.solicitud.unidades.filter(unidad => unidad.isUnitMassiveLoad);
    this.contadorUnidades = this.solicitud.unidades.length;
  }

  editUnidad(unidad: any) {
    this.unidadAEditar = this.solicitud.unidades.find(unidadSolicitud => unidadSolicitud.id === unidad.idSeqTemp);
    if (this.unidadAEditar) {
      this.borrarUnidad(unidad);
    }
  }

  formatSolicitud(solicitud: Solicitud) {
    const result = [];
    solicitud.unidades.forEach((unidad: UnidadSolicitud) => {
      result.push(this.formatUnidad(unidad));
    });
    this.unidades = result;
  }

  formatUnidad(unidad: UnidadSolicitud): any {
    const aux = {};
    unidad.campos.forEach((campo: CampoSolicitud) => {
      if (campo.multivalue) {
        aux[campo.descripcion] = [].concat(campo.valor).map(c => c.id);
      } else {
        aux[campo.descripcion] = campo.valor;
      }
    });
    aux['idSeqTemp'] = unidad.id;
    return aux;
  }

  getDirecciones() {
    let direcciones$;
    if ((this.isDocoutUser || this.isSupervisor) && this.usuarioSeleccionado) {
      direcciones$ = this.direccionesService.getDirsOfSuplantedUser(this.usuarioSeleccionado);
      direcciones$.subscribe((result: Direcciones[]) => {
        this.assignDirs(result);
      });
    } else {
      this.usersService.getUserById(undefined).subscribe((profile: Userprofile) => this.assignDirs(profile.DIRECCIONES));
    }

  }

  assignDirs(dirs: Direcciones[]) {
    if (dirs !== null) {
      this.direcciones = dirs;
      if (this.solicitud && this.solicitud && this.solicitud.idDireccion) {
        this.direcciones.forEach(dir => {
          if (dir.Id === this.solicitud.idDireccion) {
            this.direccionSeleccionada = dir;
            this.solicitud.idDireccion = dir.Id;
          }
        });
      } else {
        this.direcciones.forEach(dir => {
          // DDA 06/09/2019 => Si un usuario solo tiene la direccion de su empresa que le salga por defecto la misma
          if (dir.POR_DEFECTO || dir.DEFAULT || this.direcciones.length == 1) {
            this.direccionSeleccionada = dir;
            this.solicitud.idDireccion = dir.Id;
          }
        });
      }
    }
  }

  getTiposServicio() {
    this.tipoServicioService.getServicesType(this.isDocoutUser ? this.clienteSeleccionado : 0, this.servicioActual).subscribe(result => {
      if (result !== null && result !== undefined) {
        this.tiposServicio = result.tratamientosServicio.filter(tipo => tipo.tipoServicio === this.configServicio.nombreServicio);
        this.tiposServicio.forEach(servicio => {
          if (this.tiposTratamiento.indexOf(servicio.paramServicio) < 0) {
            if (!this.tratamiento && servicio.default) {
              this.setTratamiento(servicio.paramServicio);
            }
            this.tiposTratamiento.push(servicio.paramServicio);
          }
        });

        if (this.tiposTratamiento.length == 1) {
          this.setTratamiento(this.tiposTratamiento[0]);
        }

        this.tiposEntrega = result.entregaServicio.filter((param) => param.parametro === 'NORMAL' || param.parametro === 'URGENTE');
        if (this.tiposEntrega.some(x => x.default)) {
          this.tipoEntrega = this.tiposEntrega.find(x => x.default).parametro;
        }
        this.cargaMasiva = result.entregaServicio.some((param) => param.parametro === 'MASIVA');
        this.maxContenidos = result.maxContenidos;
      }
    });
  }
  private setTratamiento(valorTratamiento: string) {
    this.tratamiento = valorTratamiento;
    this.getEnvios();
  }

  getEnvios() {
    // this.tiposServicio.filter(tipo => tipo.paramServicio === this.tratamiento).forEach(servicio => {
    //     if (this.tiposEnvio.indexOf(servicio.tipoEnvio) < 0) {
    //         if (servicio.default) {
    //             this.envio = servicio.tipoEnvio;
    //          }
    //         this.tiposEnvio.push(servicio.tipoEnvio);
    //     }
    // });
    // 🐱‍👤 13/01/2020 => Esto estaba muy raro.
    // Lo que he montado es limpiar todos los tipos de envio que hay en la vista para poner los nuevos
    this.tiposEnvio = [];
    this.tiposServicio.filter(tipo => tipo.paramServicio == this.tratamiento)
      .forEach(servicio => this.tiposEnvio.push(servicio.tipoEnvio));

    const typeService = this.tiposServicio.find(tipo => tipo.paramServicio === this.tratamiento);

    if (typeService) {
      this.authorizationTypeServiceMessage = this.getAuthorizacionTypeService(typeService.autorizacion);
    }
    this.motivosPeticion = undefined;
    this.motivoSelect = undefined;
    if (typeService.motivosPeticion.length > 0) {
      this.motivosPeticion = typeService.motivosPeticion;
    }

    if (this.tiposEnvio.length === 1) {
      this.envio = this.tiposEnvio[0];
    }
  }
  private getAuthorizacionTypeService(authorizacion: string): string {
    if (authorizacion && authorizacion != '') {
      if (authorizacion.startsWith('USU:')) {
        return this.translateService.instant('solicitudes.userAuthorizacionMessage') + ' ' + authorizacion.substr(4);
      } else if (authorizacion.startsWith('GR:')) {
        return this.translateService.instant('solicitudes.groupAuthorizacionMessage') + ' ' + authorizacion.substr(3);
      }
    }

    return undefined;
  }

  hasShowAuthorizationTypeServiceMessage(): boolean {
    if (!this.authorizationTypeServiceMessage) { return false; }
    if ((!this.motivosPeticion || !this.motivosPeticion.length) || (this.motivoSelect && this.motivoSelect.needAutorization)) { return true; }
    return false;
  }

  getAuthorizationTypeServiceMessage() {
    return this.hasShowAuthorizationTypeServiceMessage() ? this.authorizationTypeServiceMessage : undefined;
  }

  setDeliveryAuthorization(entrega: EntregaServicio) {
    this.authorizationTypeDeliveryMessage = this.getAuthorizacionTypeService(entrega.autorizacion);
  }

  toggleExpandRowErrores(row) {
    this.tablaErroresEnvio.rowDetail.toggleExpandRow(row);
  }

  toggleExpandRow(row) {
    this.tableContenidos.rowDetail.toggleExpandRow(row);
  }

  toggleExpandRowDevolucion(row) {
    this.tableDevolucion.rowDetail.toggleExpandRow(row);
  }

  toggleExpandRowValidacion(row) {
    this.tableContenidosValidacion.rowDetail.toggleExpandRow(row);
  }

  hayCamposMultivalor(row: any): boolean {
    return this.getCamposMultivalor(row).length > 0;
  }

  hayCamposMultivalorDevolucion(contenidos: CampoSolicitud[]): boolean {
    return contenidos.some(content => content.multivalue);
  }


  setCampos(campos: TemplateField[]) {
    this.campos = campos;
    this.camposSimples = this.campos.filter((campo: TemplateField) => !campo.multivalue)
      .map((campo: TemplateField) => {
        if (campo.rango === 1) {
          campo.descripcion = `${campo.descripcion} (${this.translateService.instant('generales.from')})`;
        }
        if (campo.rango === 2) {
          campo.descripcion = `${campo.descripcion} (${this.translateService.instant('generales.to')})`;
        }
        return campo;
      });
  }

  getCamposMultivalor(row: any): string[] {
    const campos: string[] = this.campos ? this.campos.filter(campo => campo.multivalue).map(campo => campo.descripcion) : [];
    const result = campos.filter(campo =>
      row[campo] && [].concat(row[campo]).length > 0
    );
    return result;
  }

  esCampoMultivalor(descripcionCampo: string): boolean {
    return this.campos ? this.campos.filter(campo => campo.descripcion === descripcionCampo && campo.multivalue).length > 0 : false;
  }

  unidadEquivalente(unidad: UnidadSolicitud, other: any): boolean {
    let toReturn = true;
    unidad.campos.forEach((campo: CampoSolicitud) => {
      if (campo.valor !== other[campo.descripcion]) {
        toReturn = false;
      }
    });
    return toReturn;
  }

  borrarUnidad(row: UnidadSolicitud) {
    let unidadesSolicitud = this.solicitud.unidades;
    unidadesSolicitud = this.solicitud.unidades.filter(unidad => unidad.id !== row['idSeqTemp']);
    this.solicitud.unidades = unidadesSolicitud;
    if (this.maxContenidos && this.solicitud.unidades.length < this.maxContenidos) {
      this.hasAddMoreUnits = true;
    }
    this.formatSolicitud(this.solicitud);
  }

  openModal() {
    this.direccionTemplate = this.modalService.show(DireccionSolicitudesComponent, { class: 'modal-dialog modal-lg' });
    this.direccionTemplate.content.closeBtnName = 'Cerrar';
    this.direccionTemplate.content.direcciones = this.direcciones;
    this.direccionTemplate.content.idUsuario = this.isDocoutUser ? this.usuarioSeleccionado : undefined;
    this.modalService.onHide.subscribe(result => {
      if (this.direccionTemplate.content.nuevaDireccion) {
        this.direccionSeleccionada = this.direccionTemplate.content.nuevaDireccion;
        this.solicitud.idDireccion = this.direccionSeleccionada.Id;
        // console.log(this.direccionSeleccionada.Id + ' ' + this.direccionSeleccionada.NOMBRE);
      }
    });
  }

  setSerie(serie: number) {
    this.solicitud.idSerie = serie;
    this.dataSelected.serieId = serie;
    this.dataSelected = { ...this.dataSelected };
  }

  setTipoEntrega() {
    this.solicitud.normalUrgente = this.tipoEntrega;
  }

  setClienteUsuario(clienteUsuario: any) {
    if (clienteUsuario.usuario == 0) {
      this.nextStepButtonActive = false;
      this.dataSelected.clientSelected = undefined;
      this.dataSelected.userSelected = undefined;
      this.dataSelected.serieId = undefined;
      this.dataSelected = { ...this.dataSelected };
      return;
    }
    this.clienteSeleccionado = clienteUsuario.cliente;
    this.usuarioSeleccionado = clienteUsuario.usuario;
    this.dataSelected.clientSelected = clienteUsuario.cliente;
    this.dataSelected.userSelected = clienteUsuario.usuario;

    this.dataSelected = { ...this.dataSelected };

    this.solicitud.idDireccion = undefined;
    this.direccionSeleccionada = undefined;
    this.userService.getUserById(this.usuarioSeleccionado).subscribe((user: Userprofile) => {
      this.configServicio = this.serviceConfigService.getServiceConfig().serviceConfigs.find((c: ServiceConfig) => c.servicio === this.servicioActual);
      this.user = user;
      this.getDirecciones();
      this.getTiposServicio();
      this.initRadioButtons();
      this.getInstruccion(1);
      if (this.isPrestamoInventario) {
        this.nextStepButtonActive = true;
      }
    });
  }

  showTable() {
    this.tableVisible = true;
    setTimeout(() => {
      this.unidades = this.unidadesAux;
      this.unidadesAux = [];
    }, 50);
  }

  hideTable() {
    this.tableVisible = false;
    this.unidadesAux = this.unidades;
    this.unidades = [];
  }

  crearSolicitud() {
    this.loading = true;
    this.errorsContenidos = [];
    this.errorsFicheros = [];
    this.errorCodes = [];
    this.errorsToShow = [];
    this.solicitud.email = this.user.EMAIL;
    if (this.motivoSelect != undefined) {
      this.solicitud.idtipomotivo = this.motivoSelect.id;
    }
    this.solicitud.otromotivo = this.cadenaOtrosMotivos;
    this.solicitud.manualMasiva = this.filesMassiveLoadAdded.length > 0 ? 'MASIVA' : 'MANUAL';
    this.solicitud.idTipoServicio = this.tiposServicio
      .filter((tipo: TratamientoServicio) => tipo.paramServicio === this.tratamiento && tipo.tipoEnvio === this.envio)[0].id;
    this.solicitud.normalUrgente = this.tipoEntrega;
    if (this.isDocoutUser || this.isSupervisor) {
      this.solicitud.idSolicitante = this.usuarioSeleccionado;
    }
    if (!this.isPrestamoInventario) {
      this.solicitudesIds = [];
      this.guardarSolicitud();
      return;
    }
    this.crearSolicitudesPrestamosInventario();
  }

  private crearSolicitudesPrestamosInventario() {
    const expedientesPorSerie = this.getExpedientesPorSerie();
    this.solicitudesIds = [];
    expedientesPorSerie.forEach(expedientePorSerie => {
      this.solicitud.idSerie = expedientePorSerie.serie;
      this.guardarSolicitud(expedientePorSerie.expedientes);
    });
  }

  private getExpedientesPorSerie() {

    const group_to_values = this.inventoryCartInfo.identidades.reduce(function (obj, item) {
      const serieId = (item.tipoDocumental === TIPO_DOCUMENTAL.expediente) ? (<IResultadoDocument<Expedientes>>item).document.serieId
        : (item.tipoDocumental === TIPO_DOCUMENTAL.contenedor ? (<ContenedorDetail>item).seriesId[0] : (<AzDetail>item).idSerie);
      obj[serieId] = obj[serieId] || [];
      obj[serieId].push(item);
      return obj;
    }, {});

    const groups = Object.keys(group_to_values).map(key => {
      return {
        serie: parseInt(key, 10),
        expedientes: group_to_values[key] as IResultadoDocument<Expedientes>[]
      };
    });

    return groups;
  }


  private guardarSolicitud(expedientes?: IResultadoDocument<Expedientes>[]): any {

    if (!expedientes) {
      this.solicitud = this.getSolicitudPeticionesSinPrestamoInventario();
    } else {
      this.solicitud = this.getSolicitudPeticionesPrestamoInventario(expedientes);
    }

    this.manageFilesBeforeSaveSolicitud(this.solicitud, expedientes);
  }
  private manageFilesBeforeSaveSolicitud(solicitud: Solicitud, expedientes?: IResultadoDocument<Expedientes>[]) {
    this.solicitud.hasFiles = !!this.filesMassiveLoadAdded.length || !!this.filesAttachRequest.length;
    if (this.filesMassiveLoadAdded.length || this.filesAttachRequest.length) {
      this.filesInExecution = new Map();
      this.filesMassiveLoadAdded.forEach((fileData: FileData) => {
        const observableNumber = this.observablesFicheros.size;
        this.filesInExecution.set(observableNumber, fileData);
        this.observablesFicheros.set(observableNumber, this.fileManagerService.uploadFileToRepository(fileData.file, true, FileType.CARGA_MASIVA)
          .pipe(catchError((response: Response) => {
            return of(-1);
          })));
      });
      this.filesAttachRequest.forEach((fileData: FileData) => {
        const observableNumber = this.observablesFicheros.size;
        this.filesInExecution.set(observableNumber, fileData);
        this.observablesFicheros.set(observableNumber, this.fileManagerService.uploadFileToRepository(fileData.file, true, FileType.DOCUMENTACION)
          .pipe(catchError((response: Response) => {
            return of(-1);
          })));
      });
      this.manageObservablesFicheros(expedientes);

      return;
    }

    this.sendSaveSolicitud(expedientes);
  }
  private manageObservablesFicheros(expedientes?: IResultadoDocument<Expedientes>[]) {
    const output: Observable<any> = this.concatObservables(this.observablesFicheros);
    let indiceEjecucion = 0;

    output.subscribe(resultSecuencial => {
      if (resultSecuencial !== 0 && resultSecuencial !== -1) {
        this.filesInExecution.get(indiceEjecucion).guid = resultSecuencial;
        if (indiceEjecucion === this.observablesFicheros.size - 1 && this.errorsToShow.length === 0) {
          this.sendSaveSolicitud(expedientes);
        }
      } else {
        if (!this.isPrestamoInventario && resultSecuencial < 0) {
          this.putErrorsCodesSinPrestamoInventario(indiceEjecucion);
        }
        if (indiceEjecucion === this.observablesFicheros.size - 1) {
          this.loading = false;
        }
      }
      indiceEjecucion++;
    });
  }
  private sendSaveSolicitud(expedientes?: IResultadoDocument<Expedientes>[]) {
    this.solicitudServicioService.comprobarRestaurarSerieDocumentalInterna(this.solicitud.idSerie)
      .subscribe(
        (r: any) => console.log('ok')
      );
    this.solicitudServicioService.crearSolicitud(this.solicitud).subscribe((result: any) => {
      if (!result || !result.ID_SOLICITUD_SERVICIO || result.ID_SOLICITUD_SERVICIO <= 0) {
        if (console) {
          // console.log('No se ha podido crear la solicitud');
        }
        this.errorCodes.push('SOLICITUD');
        this.errorsToShow.push({ id: this.errorsToShow.length + 1, errorCode: 'SOLICITUD', errorElement: undefined });
        this.errorsToShow = [...this.errorsToShow];
        this.loading = false;
      } else {
        this.solicitudesIds.push(result.ID_SOLICITUD_SERVICIO);
        let observables: Map<number, Observable<any>> = new Map();

        if (this.observaciones !== undefined && this.observaciones !== null && this.observaciones.trim() !== '') {
          observables.set(observables.size, this.observacionesSolicitudService.addObservaciones(
            this.solicitudesIds[this.solicitudesIds.length - 1],
            this.observaciones, false, this.user.Id, false)
            .pipe(catchError((response: Response) => {
              return of(-1);
            })));
        }

        if (this.filesInExecution && this.filesInExecution.size > 0) {
          this.filesInExecution.forEach(fileInExecution => {
            observables = this.manageFilesInExecution(fileInExecution.guid, observables);
          });
        }

        if (observables.size > 0) {
          const output: Observable<any> = this.concatObservables(observables);
          let indiceEjecucion = 0;
          output.subscribe(resultSecuencial => {
            if (resultSecuencial !== 0 && resultSecuencial !== -1 &&
              indiceEjecucion === observables.size - 1 && this.errorsToShow.length === 0) {
              this.finishRequestWithoutErrors();
            } else {
              if (!this.isPrestamoInventario && resultSecuencial < 0) {
                this.putErrorsCodesSinPrestamoInventario(indiceEjecucion);
              }
              if (indiceEjecucion === observables.size - 1) {
                this.loading = false;
              }
            }
            indiceEjecucion++;
          });
        } else {
          this.loading = false;
        }

        if (expedientes) {
          this.eliminarExpedientesEnCarrito(expedientes);
        }
      }
    },
      error => {
        this.solicitudesIds = undefined;
        if (console) {
        }
        this.errorCodes.push('SOLICITUD');
        this.errorsToShow.push({ id: this.errorsToShow.length + 1, errorCode: 'SOLICITUD', errorElement: undefined });
        this.errorsToShow = [...this.errorsToShow];
        this.loading = false;
      });
  }
  private finishRequestWithoutErrors(): any {
    this.observablesFicheros = new Map();
    this.filesInExecution = undefined;
    this.loading = false;
  }

  private eliminarExpedientesEnCarrito(expedientes: IResultadoDocument<Expedientes>[]) {
    expedientes.forEach(expediente => {
      this.shoppingElementsService.removeElement(expediente);
    });
  }
  private concatObservables(observables: Map<number, Observable<any>>): Observable<any> {
    let output: Observable<any> = observables.get(0);
    for (let x = 1; x < observables.size; x++) {
      output = concat(output, observables.get(x));
    }
    return output;
  }

  private manageFilesInExecution(guid: string,
    observables: Map<number, Observable<any>>): Map<number, Observable<any>> {

    observables.set(observables.size, this.fileManagerService.associateFileToRequest(
      this.solicitudesIds[this.solicitudesIds.length - 1], guid
    ).pipe(catchError((response: Response) => {
      return of(-1);
    })));

    return observables;
  }
  getSolicitudPeticionesPrestamoInventario(inventoryElements: InventoryIdenty[]): Solicitud {
    const contenidosInventariados: ContenidoInventariado[] = [];
    inventoryElements.forEach((inventoryElement: InventoryIdenty) => {
      const contenidoInventariado = new ContenidoInventariado();
      contenidoInventariado.tipoUnidadDocumental = inventoryElement.tipoDocumental;
      contenidoInventariado.observacionParcial = inventoryElement.shoppingCart.obsPartial;
      contenidoInventariado.idInventario = inventoryElement.id.toString();
      contenidosInventariados.push(contenidoInventariado);
    });

    this.solicitud.contenidosInventario = contenidosInventariados;

    return this.solicitud;
  }
  putErrorsCodesSinPrestamoInventario(indiceEjecucion: number): any {
    if (this.filesInExecution.has(indiceEjecucion)) {
      this.errorCodes.push('FICHEROS');
      const file = this.filesInExecution.get(indiceEjecucion);
      this.errorsFicheros.push(file);
      this.errorsToShow.push({
        id: this.errorsToShow.length + 1, errorCode: 'FICHEROS',
        errorElement: file
      });
      this.errorsToShow = [...this.errorsToShow];
    } else if (indiceEjecucion < this.solicitud.unidades.length) {
      this.errorCodes.push('SERIES');
      this.errorsContenidos.push(this.solicitud.unidades[indiceEjecucion]);
      this.errorsToShow.push({ id: this.errorsToShow.length + 1, errorCode: 'SERIES', errorElement: this.solicitud.unidades[indiceEjecucion] });
      this.errorsToShow = [...this.errorsToShow];
    } else if (indiceEjecucion < this.solicitud.unidades.length + this.filesMassiveLoadAdded.length) {
      this.errorCodes.push('FICHEROS');
      this.errorsFicheros.push(this.filesMassiveLoadAdded[indiceEjecucion - this.solicitud.unidades.length]);
      this.errorsToShow.push({
        id: this.errorsToShow.length + 1, errorCode: 'FICHEROS',
        errorElement: this.filesMassiveLoadAdded[indiceEjecucion - this.solicitud.unidades.length]
      });
      this.errorsToShow = [...this.errorsToShow];
    } else {
      this.errorCodes.push('OBSERVACIONES');
      this.errorsToShow.push({ id: this.errorsToShow.length + 1, errorCode: 'OBSERVACIONES', errorElement: undefined });
      this.errorsToShow = [...this.errorsToShow];
    }
  }
  getSolicitudPeticionesSinPrestamoInventario(): Solicitud {
    const contenidosInventariados: ContenidoInventariado[] = [];
    const contenidosNoInventariados: ContenidoNoInventariado[] = [];

    if (this.servicioActual === 'devolucion') {
      this.rowsDevolucionesSelected.forEach((contenidoDevolucion: TableContentInfo) => {
        if (contenidoDevolucion.isInventario) {
          const contenidoInventariado = new ContenidoInventariado();
          contenidoInventariado.idContenido = contenidoDevolucion.contenidoId;
          contenidoInventariado.tipoUnidadDocumental = contenidoDevolucion.tipoUnidadDoc;
          contenidoInventariado.observacionParcial = contenidoDevolucion.obsParcial;
          contenidoInventariado.idInventario = contenidoDevolucion.inventarioId;
          contenidosInventariados.push(contenidoInventariado);
        } else {

          const campos: CampoSolicitud[] = this.convertToCampoSolicitud(contenidoDevolucion.campos);

          const contenidoNoInventariado = this.getContenidoNoInventariado(campos);
          contenidosNoInventariados.push(contenidoNoInventariado);
        }
      });

      if (!!this.solicitud && this.solicitud.unidades.length) {
        this.solicitud.unidades.map(unit => {
          const contenidoNoInventariado = this.getContenidoNoInventariado(unit.campos);
          contenidosNoInventariados.push(contenidoNoInventariado);
        });
      }
    } else {
      this.solicitud.unidades.forEach((unidad: UnidadSolicitud) => {
        const contenidoNoInventariado = this.getContenidoNoInventariado(unidad.campos);
        contenidosNoInventariados.push(contenidoNoInventariado);
      });
    }

    this.solicitud.contenidosInventario = contenidosInventariados;
    this.solicitud.contenidosNoInvetariados = contenidosNoInventariados;

    return this.solicitud;
  }
  private getContenidoNoInventariado(campos: CampoSolicitud[]): ContenidoNoInventariado {
    const valoresSerie: ValorCampoSerie[] = this.getValoresSerie(campos);
    return this.getContenidoNoInventarioDesdeValoresCamposSeries(valoresSerie);
  }
  private getContenidoNoInventarioDesdeValoresCamposSeries(valoresSerie: ValorCampoSerie[]): ContenidoNoInventariado {
    const camposValor = valoresSerie.map(valorSerie => CampoValor.toModel(JSON.stringify(valorSerie)));
    const contenidoNoInventariado = new ContenidoNoInventariado();
    contenidoNoInventariado.campos = camposValor;
    return contenidoNoInventariado;
  }
  private convertToCampoSolicitud(campos: any[]): CampoSolicitud[] {
    return Object.keys(campos).map(nameCampo => {
      const value = campos[nameCampo];
      if (value && value != '') {
        const requestField = new CampoSolicitud();
        requestField.nombre = nameCampo;
        requestField.valor = value;
        return requestField;
      }
    }).filter(campo => campo);
  }

  getValoresSerie(campos: CampoSolicitud[]): ValorCampoSerie[] {
    const valoresSerie = [];
    campos.forEach((campo: CampoSolicitud) => {
      if (!campo.multivalue && campo.valor) {
        if (campo.valor instanceof Date) {
          valoresSerie.push(new ValorCampoSerie(campo.nombre, (<Date>campo.valor).toISOString()));
        } else {
          valoresSerie.push(new ValorCampoSerie(campo.nombre, '' + campo.valor));
        }
      }
      if (campo.multivalue && campo.valor && [].concat(campo.valor).length > 0) {
        [].concat(campo.valor).forEach(v => valoresSerie.push(new ValorCampoSerie(campo.nombre, '' + v.id, campo.id)));
      }
    });

    return valoresSerie;
  }

  reintentarCreacionSolicitud() {
    this.reintentado = true;
    if (this.errorCodes.indexOf('SOLICITUD') >= 0) {
      this.crearSolicitud();
      return;
    }
    this.loading = true;
    let valoresSerie: ValorCampoSerie[];
    const observables: Map<number, Observable<any>> = new Map();
    let contador = 0;
    if (this.errorCodes.indexOf('SERIES') >= 0) {
      const contenidosNoInventariados: ContenidoNoInventariado[] = [];
      this.errorsContenidos.forEach((unidad: UnidadSolicitud) => {
        valoresSerie = [];
        unidad.campos.forEach((campo: CampoSolicitud) => {
          if (!campo.multivalue && campo.valor) {
            if (campo.valor instanceof Date) {
              valoresSerie.push(new ValorCampoSerie(campo.nombre, (<Date>campo.valor).toISOString()));
            } else {
              valoresSerie.push(new ValorCampoSerie(campo.nombre, '' + campo.valor));
            }
          }
          if (campo.multivalue && campo.valor && [].concat(campo.valor).length > 0) {
            [].concat(campo.valor).forEach(v => valoresSerie.push(new ValorCampoSerie(campo.nombre, '' + v, campo.id)));
          }
        });
        contenidosNoInventariados.push(this.getContenidoNoInventarioDesdeValoresCamposSeries(valoresSerie));
        this.sendSaveSolicitud();
      });
    }

    if (this.errorCodes.indexOf('FICHEROS') >= 0) {
      this.errorsFicheros.forEach((file: FileData) => {
        valoresSerie = [];
        if (!file.guid) {
          observables.set(contador++, this.fileManagerService.uploadFileToRepository(file.file, true, FileType.CARGA_MASIVA)
            .pipe(catchError(response => of(-1)),
              tap(result => {
                if (result !== 0 && result !== -1) {
                  this.fileManagerService.associateFileToRequest(
                    this.solicitudesIds[this.solicitudesIds.length - 1],
                    result as string)
                    .pipe(catchError((response: Response) => {
                      return of(-1);
                    })).subscribe();
                }
              })));
        } else {
          observables.set(contador++, this.fileManagerService.associateFileToRequest(
            this.solicitudesIds[this.solicitudesIds.length - 1],
            file.guid)
            .pipe(catchError((response: Response) => {
              return of(-1);
            })));
        }
      });
    }

    if (this.errorCodes.indexOf('OBSERVACIONES') >= 0) {
      observables.set(contador++, this.observacionesSolicitudService
        .addObservaciones(this.solicitudesIds[this.solicitudesIds.length - 1], this.observaciones, false, this.user.Id, false)
        .pipe(catchError((response: Response) => {
          return of(-1);
        })));
    }

    const lastErrorsContenidos = this.errorsContenidos;
    const lastErrorsFicheros = this.errorsFicheros;
    this.errorCodes = [];
    this.errorsContenidos = [];
    this.errorsFicheros = [];
    this.errorsToShow = [];
    if (observables.size > 0) {
      let output: Observable<any> = observables.get(0);
      for (let x = 1; x < observables.size; x++) {
        output = concat(output, observables.get(x));
      }
      let indiceEjecucion = 0;
      output.subscribe(resultSecuencial => {
        if (resultSecuencial !== 0 && resultSecuencial !== -1) {
          if (indiceEjecucion === observables.size - 1) {
            this.loading = false;
          }
        } else {
          if (indiceEjecucion < lastErrorsContenidos.length) {
            this.errorCodes.push('SERIES');
            this.errorsContenidos.push(this.solicitud.unidades[indiceEjecucion]);
            this.errorsToShow.push({ id: this.errorsToShow.length + 1, errorCode: 'SERIES', errorElement: lastErrorsContenidos[indiceEjecucion] });
            this.errorsToShow = [...this.errorsToShow];
          } else if (indiceEjecucion < lastErrorsContenidos.length + lastErrorsFicheros.length) {
            this.errorCodes.push('FICHEROS');
            this.errorsFicheros.push(this.filesMassiveLoadAdded[indiceEjecucion - this.solicitud.unidades.length]);
            this.errorsToShow.push({
              id: this.errorsToShow.length + 1, errorCode: 'FICHEROS',
              errorElement: lastErrorsFicheros[indiceEjecucion - lastErrorsContenidos.length]
            });
            this.errorsToShow = [...this.errorsToShow];
          } else {
            this.errorCodes.push('OBSERVACIONES');
            this.errorsToShow.push({ id: this.errorsToShow.length + 1, errorCode: 'OBSERVACIONES', errorElement: undefined });
            this.errorsToShow = [...this.errorsToShow];
          }
          if (indiceEjecucion === observables.size - 1) {
            this.loading = false;
          }
        }
        indiceEjecucion++;
      });
    }
  }

  getValorSelect(unidad: any, campo?: TemplateField, nombreCampo?: string): string {
    if (!campo && !nombreCampo) {
      return '';
    }
    if (!campo && nombreCampo) {
      campo = this.campos.filter(campoAux => campoAux.descripcion === nombreCampo)[0];
    }
    if (unidad[campo.descripcion]) {
      if (campo.multivalue) {
        const aux = campo.defaultValues.filter((value: SelectValue) =>
          [].concat(unidad[campo.descripcion]).indexOf(value.id) >= 0);
        return aux.map(v => v.descripcion).join(', ');
      } else {
        const aux = campo.defaultValues.filter((value: SelectValue) => {
          if (campo.subtipo === 'BIGDATA') {
            return value.valor == unidad[campo.descripcion].toString()
              || value.descripcion == unidad[campo.descripcion].toString();
          }
          return value.id === +unidad[campo.descripcion];
        });
        return !!aux && aux.length > 0 ? aux[0].descripcion : '';
      }
    }
    return '';
  }

  getAlbaran(solicitud: number) {
    this.albaran.getAlbaranSolicitud(solicitud);
  }

  private resetComponent() {
    this.Title = undefined;
    this.Description = undefined;
    this.Padre = undefined;
    this.Hijo = undefined;

    this.direccionSeleccionada = undefined;
    this.direcciones = undefined;
    this.tiposServicio = [];
    this.tiposTratamiento = [];
    this.tiposEnvio = [];
    this.tiposEntrega = [];
    this.campos = undefined;
    this.solicitud = new Solicitud();
    this.unidades = [];
    this.tipoEntrega = undefined;
    this.tratamiento = undefined;
    this.envio = undefined;
    this.user = undefined;
    this.tableVisible = false;
    this.solicitudesIds = undefined;
    this.observaciones = undefined;
    this.servicioActual = undefined;
    this.configServicio = undefined;
    this.loading = false;
    this.errorCodes = [];
    this.errorsContenidos = [];
    this.errorsFicheros = [];
    this.errorsToShow = [];
    this.reintentado = false;
    this.clienteSeleccionado = undefined;
    this.usuarioSeleccionado = undefined;
    this.campoEdicion = undefined;
    this.registroEdicion = undefined;
    this.instruccion = undefined;
    this.camposSimples = [];
    this.filesMassiveLoadAdded = [];
    this.nextStepButtonActive = false;
    this.unidadesAux = [];
    this.filesAttachRequest = [];
    this.carouselFiles = [];
    if (this.plantilla) {
      this.plantilla.ngOnDestroy();
      this.plantilla.ngOnInit();
    }
    this.rowsDevolucionesSelected = [];
  }

  nuevaSolicitud() {
    this.direccionSeleccionada = undefined;
    this.direcciones = undefined;
    this.tiposServicio = [];
    this.tiposTratamiento = [];
    this.tiposEnvio = [];
    this.tiposEntrega = [];
    this.campos = undefined;
    this.unidades = [];
    this.tipoEntrega = undefined;
    this.tratamiento = undefined;
    this.envio = undefined;
    this.tableVisible = false;
    this.solicitudesIds = undefined;
    this.observaciones = undefined;
    this.errorCodes = [];
    this.errorsContenidos = [];
    this.errorsFicheros = [];
    this.errorsToShow = [];
    this.reintentado = false;
    this.init();
    if (this.plantilla) {
      this.plantilla.ngOnDestroy();
      this.plantilla.ngOnInit();
    }
    this.campoEdicion = undefined;
    this.registroEdicion = undefined;
    this.instruccion = undefined;
    this.wizard.navigation.reset();
    this.camposSimples = [];
    this.filesMassiveLoadAdded = [];
    this.filesAttachRequest = [];
    this.carouselFiles = [];
    if (this.isDocoutUser) {
      this.nextStepButtonActive = false;
    }
    this.solicitud = new Solicitud();
    this.unidadesAux = [];
  }

  setPrestamos(contadorDevoluciones: ContadorContenidos) {

    if (!contadorDevoluciones) {
      this.tratamiento = undefined;
      return;
    }
    this.contadorDevoluciones = contadorDevoluciones;
  }

  canSelect(campo: TemplateField, row: any): boolean {
    return true;
  }

  getPrestamoId(row: any): number {
    return row.Id;
  }

  startEdit(campo: TemplateField, row: any) {
    this.campoEdicion = campo;
    this.registroEdicion = row;
  }

  editing(campo: TemplateField, row: any) {
    return this.campoEdicion && this.registroEdicion && this.campoEdicion.id === campo.id && row.id === this.registroEdicion.id;
  }

  finishEdit(event: any) {
    this.campoEdicion = undefined;
    this.registroEdicion = undefined;
  }

  onSelect({ selected }) {
    const auxSeleccionados = [];
    // console.log('Select Event', selected, this.prestamosSeleccionados);

    // Nos quedamos con los anteriormente seleccionados que no lo estén ahora porque no son visibles
    /* this.prestamosSeleccionados.forEach(sel => {
        const prestamosFormateadosPorId = this.prestamosFormateados.filter(prestamoFormateado =>
                                                                        prestamoFormateado.contenidos['id'] == sel.contenidos['id']
                                                                    );
        if (prestamosFormateadosPorId.length === 0 &&
            selected.filter(prestamo => prestamo.id === sel.contenidos['id']).length === 0) {
            auxSeleccionados.push(sel);
        }
    }); */

    // Añadimos a los seleccionados sin repeticiones
    selected.forEach(newSel => {
      if (auxSeleccionados.filter(sel => sel.contenidos['id'] === newSel.contenidos['id']).length === 0) {
        auxSeleccionados.push(newSel);
      }
    });
    if (this.unidades) {
      this.unidades.splice(0, this.solicitud.unidades.length);
      this.unidades.push(...auxSeleccionados);
      this.solicitud.unidades.splice(0, this.solicitud.unidades.length);

      this.unidades.forEach(prestamo => {
        const aux = new UnidadSolicitud();
        let campoSolicitud: CampoSolicitud;
        this.campos.forEach((campo: TemplateField) => {
          campoSolicitud = new CampoSolicitud();
          campoSolicitud.id = campo.id;
          campoSolicitud.descripcion = campo.descripcion;
          campoSolicitud.nombre = campo.nombre;
          campoSolicitud.valor = prestamo[campo.descripcion];
          aux.campos.push(campoSolicitud);
        });
        this.solicitud.unidades.push(aux);
      });
    }

  }

  /* refreshSelected() {
      const aux = [];
      this.prestamosSeleccionados.forEach(prestamo => {

          if (this.prestamosFormateados.filter(p => p.contenidos['id'] === prestamo.contenidos['id']).length > 0) {
              aux.push(this.prestamosFormateados.filter(p => p.contenidos['id'] === prestamo.contenidos['id'])[0]);
          } else {
              aux.push(prestamo);
          }
      });
      this.prestamosSeleccionados.splice(0, this.prestamosSeleccionados.length);
      this.prestamosSeleccionados.push(...aux);
  } */

  getInstruccion(stepId) {
    if (stepId === 1 && this.clienteSeleccionado === undefined && this.isDocoutUser) {
      return;
    }
    const request = new InstruccionRequest();
    request.ID_PASO = stepId;
    request.ROUTE = this.servicioActual;
    request.PREFIJO_IDIOMA = localStorage.getItem('idioma');
    request.ID_CLIENTE = this.isDocoutUser ? this.clienteSeleccionado : 0;
    this.instruccionesService.getServicesType(request).subscribe((result: Instruccion) => this.instruccion = result ? result.MENSAJE : null);

    if (this.wizard) {
      const step = this.wizard.wizardSteps.find(s => s.stepTitle.startsWith('' + stepId));
      this.stepTitle = step.stepTitle;
    }
  }

  onResized(event: ResizedEvent): void {
    if (this.tableContenidosValidacion !== undefined) {
      setTimeout(() => {
        this.tableContenidosValidacion.recalculate();
        window.dispatchEvent(new Event('resize'));
      }, (50));
    }
  }

  onResizedContenidos(event: ResizedEvent): void {
    if (this.tableContenidos !== undefined) {
      setTimeout(() => {
        this.tableContenidos.recalculate();
        window.dispatchEvent(new Event('resize'));
      }, (50));
    }
  }

  onResizedContenidosFileMassiveLoad(event: ResizedEvent): void {
    if (this.tableContenidosFileMassiveLoad !== undefined) {
      setTimeout(() => {
        this.tableContenidosFileMassiveLoad.recalculate();
        window.dispatchEvent(new Event('resize'));
      }, (50));
    }
  }

  onResizedFilesMassiveLoad(event: ResizedEvent): void {
    if (this.tableFilesMassiveLoad !== undefined) {
      setTimeout(() => {
        this.tableFilesMassiveLoad.recalculate();
        window.dispatchEvent(new Event('resize'));
      }, (50));
    }
  }

  onResizedContenidosValidacion(event: ResizedEvent): void {
    if (this.tableContenidosValidacion !== undefined) {
      setTimeout(() => {
        this.tableContenidosValidacion.recalculate();
        window.dispatchEvent(new Event('resize'));
      }, (50));
    }
  }

  onResizedDevolucion(event: ResizedEvent): void {
    if (this.tableDevolucion !== undefined) {
      setTimeout(() => {
        this.tableDevolucion.recalculate();
        window.dispatchEvent(new Event('resize'));
      }, (50));
    }
  }

  downloadCSVData(values) {
    const csv = this.generateCSVFromValues(values);

    const fileName = this.translateService.instant('devolucion.exportFileName') + '.csv';

    this.utilservice.downloadDataInCSV(fileName, csv);

  }

  /*downloadCSVDevoluciones(prestamos: DatosPrestamo[]) {
      let csv = this.campos.map(column => column.descripcion).join(';');
      csv += ';Fecha expiración';
      csv += (this.isSupervisor || this.isDocoutUser) ? ';Usuario Solicitante\n' : '\n'

      let valores: any[];
      prestamos.forEach(prestamo => {
          console.log(prestamo);
          valores = this.campos.map(campo => {
              console.log(campo);
              let campoContenido = prestamo.contenidos.find(contenido => contenido.descripcion === campo.descripcion);
              if (campoContenido) {
                  if (campo.tipo === 'ARRAY') {
                      if (campoContenido.multivalue) {
                          return [].concat(campoContenido.valor).join(' | ');
                      } else {
                          return campoContenido.valor;
                      }
                  } else {
                      return campoContenido.valor;
                  }
              } else {
                  return '';
              }
          });
          // csv += `;${pipe.transform(prestamo.fechaExpiracion, 'dd-MM-yyyy')}`
          csv += valores.join(';');
          csv += prestamo.fechaExpiracion ? `;${this.datePipe.transform(new Date(prestamo.fechaExpiracion), 'dd-MM-yyyy')}` : ';';
          csv += (this.isSupervisor || this.isDocoutUser) ? `;${prestamo.usuario}\n` : '\n'
      });

      const fileName = this.translateService.instant('devolucion.exportFileName') + '.csv';
      this.utilservice.downloadDataInCSV(fileName, csv);
  }*/

  private generateCSVFromValues(values: any): string {
    let csvString = this.convertValuesToCSVRow(this.campos.map(column => column.descripcion));

    values.forEach(value => {
      csvString += this.convertValuesToCSVRow(this.campos.map(column => value.contenidos[column.descripcion]));
    });

    return csvString;
  }

  private convertValuesToCSVRow(values: any[]): string {
    return values.join(';') + '\n';
  }

  registerNewFileGuid(fileData: FileData) {
    this.filesMassiveLoadAdded.push(fileData);
    this.filesMassiveLoadAdded = [...this.filesMassiveLoadAdded];
  }

  attachDocumentToRequest(filesData: FileData[]) {
    this.filesAttachRequest = [...this.filesAttachRequest, ...filesData];
    this.filesAttachRequest = this.cleanRepeatFiles(this.filesAttachRequest);
    this.carouselFiles = this.createCarouselFiles(this.filesAttachRequest);
  }

  private cleanRepeatFiles(files: FileData[]): FileData[] {
    if (files && files.length) {
      const filesNoRepeated: FileData[] = [];
      files.forEach(file => {
        if (!this.isRepeated(file, filesNoRepeated)) {
          filesNoRepeated.push(file);
        }
      });

      return [...filesNoRepeated];
    }
    return null;
  }

  private isRepeated(file: FileData, files: FileData[]): boolean {
    return files.some(fil =>
      fil.file.lastModified == file.file.lastModified && fil.file.name == file.file.name
      && fil.file.size == file.file.size && fil.file.type == file.file.type
    );
  }

  isServiceToAttachFiles() {
    return this.servicioActual === 'prestamos' || this.servicioActual === 'recogida' || this.servicioActual === 'entrega' || this.servicioActual === 'expurgo';
  }
  private createCarouselFiles(filesData: FileData[]): { name: string, guid: string, date: string, fileData: any }[] {

    return filesData.map(fileData => {
      return {
        name: fileData.filename,
        guid: fileData.guid,
        date: this.datePipe.transform(fileData.file.lastModified, 'yyyy-MM-ddTHH:mm:') + '00',
        fileData: fileData.file
      };
    });
  }

  chargeInventoryRecord(idExpediente) {
    this.inventoryService.goToRecordDetailById(idExpediente);
  }

  showModalText(obsPartial) {
    const modalTitle = 'inventory.obsPartial';
    const modalTextConfirm = 'generales.ok';
    const disabled = true;
    const showCloseButton = false;
    const modal = this.modalService.show(ModalShowTextComponent);
    (<ModalShowTextComponent>modal.content).showTextModal(
      modalTitle,
      obsPartial,
      modalTextConfirm,
      disabled,
      showCloseButton
    );
  }

  isFirstButtonNextDisabled() {
    return !(this.tieneFicherosCargaMasiva() ||
      this.tienePrestamosSeleccionados() ||
      this.tieneActivadoPasarAlSegundoPaso()
      || this.tieneDevolucionesSeleccionadas()
      || this.tieneDevolucionPorDatos());
  }
  private tieneDevolucionPorDatos(): boolean {
    return this.isFormularioPlantillaValid && !!this.solicitud
      && this.solicitud.unidades && this.solicitud.unidades.length > 0;
  }

  isSecondButtonNextDisabled() {
    if (!this.configServicio) {
      return true;
    }
    return (this.configServicio.opciones && (!this.tratamiento || !this.envio))
      || (this.configServicio.parametros && !this.tipoEntrega) || (this.configServicio.direccion
        && !this.direccionSeleccionada) || (this.motivosPeticion && !this.motivoSelect);
  }

  private tieneFicherosCargaMasiva(): boolean {
    return this.filesMassiveLoadAdded.length > 0;
  }

  tienePrestamosSeleccionados(): boolean {
    return /*(this.isPrestamoValidoSinUnidades() && this.isFormularioPlantillaValid) ||*/ (this.unidades && this.unidades.length > 0);
  }
  private isPrestamoValidoSinUnidades() {
    return (!!this.maxContenidos && this.maxContenidos > 1) || this.isDevolucionByData();
  }

  private tieneActivadoPasarAlSegundoPaso(): boolean {
    return this.nextStepButtonActive;
  }

  private tieneDevolucionesSeleccionadas(): boolean {
    return this.servicioActual === 'devolucion' && this.rowsDevolucionesSelected.length > 0;
  }
  getValorDevolucion(row, descripcion) {
    const contenido = row.contenidos.find(content => content.descripcion == descripcion);
    return contenido ? contenido.valor : '';
  }

  getCamposMultivalorDevolucion(contenidos: CampoSolicitud[]) {
    return contenidos.filter(content => content.multivalue);
  }

  onSelectDevolucion($event) {
  }

  hayCamposMultivalorValidacion(contenidos) {
    return contenidos.some(content => content.multivalue);
  }

  getCamposMultivalorValidacion(contenidos: CampoSolicitud[]) {
    return contenidos.filter(content => content.multivalue);
  }

  downloadFileMassiveLoad(row: FileData) {
    this.utilservice.downloadGenericFile(row.filename, row.file);
  }

  removeFileMassiveLoad(row: FileData) {
    const index = this.filesMassiveLoadAdded.indexOf(row);
    if (index > -1) {
      this.filesMassiveLoadAdded.splice(index, 1);
      this.filesMassiveLoadAdded = [...this.filesMassiveLoadAdded];
      if (!this.filesMassiveLoadAdded.length && this.isDevolucionByData()) {
        this.unidadesPorCargaMasivaEnDevolucionByData = [];
        this.solicitud.unidades = this.solicitud.unidades.filter(unit => !unit.isUnitMassiveLoad);
      }
    }
  }

  goToRelationRequest(solicitudRelacionada: number, contenidoRelacionado: number) {

    this.router.navigate(['docout', {
      outlets: {
        contenido: ['detalle', solicitudRelacionada, {
          contenidoSeleccionado: contenidoRelacionado
        }]
      }
    }]);
  }

  onSelectDevoluciones(devoluciones) {
    console.log(devoluciones);
  }

  setContenidosNoInventariados(contenidosNoInventariados: TableContentInfo[]) {
    this.rowsContenidosNoInventariados = contenidosNoInventariados;
  }

  setContenidosExpedientes(contenidosExpedientes: TableContentInfo[]) {
    this.rowsContenidosExpedientes = contenidosExpedientes;
  }

  setContenidosContenedores(contenidosContenedores: TableContentInfo[]) {
    this.rowsContenidosContenedores = contenidosContenedores;
  }

  setContenidosAZs(contenidosAZs: TableContentInfo[]) {
    this.rowsContenidosAZs = contenidosAZs;
  }

  hasAllContents(hasAllContents: boolean) {
    if (hasAllContents) {
      this.hasDevoluciones = this.hasContents();
      this.cargandoDevoluciones = false;
    }
  }

  private hasContents() {
    const hasDataNoInventariados = this.rowsContenidosNoInventariados && this.rowsContenidosNoInventariados.length > 0;
    const hasDataExpedientes = this.rowsContenidosExpedientes && this.rowsContenidosExpedientes.length > 0;
    const hasDataContenedores = this.rowsContenidosContenedores && this.rowsContenidosContenedores.length > 0;
    const hasDataAz = this.rowsContenidosAZs && this.rowsContenidosAZs.length > 0;
    return hasDataNoInventariados || hasDataExpedientes || hasDataContenedores || hasDataAz;
  }

  setLoadingDevoluciones(loading: boolean) {
    this.cargandoDevoluciones = true;
  }

  getUnidadConError(row: { id: number, errorCode: string, errorElement: any }): any[] {
    return [].concat(this.formatUnidad(row.errorElement));
  }

  setFiltroDevoluciones(filtro: FiltroDevolucion) {
    this.filtroDevolucion = filtro;
  }

  removeUnit(unidad) {
    this.unidades = this.unidades.filter(item => item.idSeqTemp !== unidad.idSeqTemp);
    this.solicitud.unidades = this.solicitud.unidades.filter(item => item.id != unidad.idSeqTemp);
  }

  removeCarouselFiles(files: { name: string, guid: string, date: string }[]) {
    this.filesAttachRequest = this.filesAttachRequest.filter(fileAttachRequest =>
      !files.some(file => file.guid == fileAttachRequest.guid && file.name == fileAttachRequest.filename)
    );
    this.carouselFiles = this.createCarouselFiles(this.filesAttachRequest);
  }

  setFormularioPlantillaValid(isFormularioPlantillaValid) {
    if (this.servicioActual == 'devolucion') {
      this.isFormularioPlantillaValid = isFormularioPlantillaValid;
    }
  }

  resetUnitDevoluciones(hasReset: boolean) {
    if (hasReset) {
      this.isFormularioPlantillaValid = false;

      if (this.isDevolucionByData()) {
        this.solicitud.unidades = this.solicitud.unidades.filter(unidad => unidad.isUnitMassiveLoad);
        this.contadorUnidades = this.solicitud.unidades.length;
        this.unidades = this.unidades.filter(unidad => unidad.isUnitMassiveLoad);
      }
    }
  }

  hasDataSelected() {
    return this.dataSelected.needDataToShowData && !!this.dataSelected.serieId;
  }

  isDevolucionByData(): boolean {
    return !this.isPrestamoInventario && this.servicioActual === 'devolucion' && this.hasInitialData
      && this.returnWithoutLoan && this.returnWithoutLoan.puedeHacerDevolucionSinPrestamo;
  }

  hasUnitMassiveLoad(): boolean {
    return this.unidadesPorCargaMasivaEnDevolucionByData && !!this.unidadesPorCargaMasivaEnDevolucionByData.length;
  }

  borrarUnidadCargaMasivaDevolucionesByData(row) {
    this.unidadesPorCargaMasivaEnDevolucionByData = this.unidadesPorCargaMasivaEnDevolucionByData
      .filter(unit => unit.idSeqTemp !== row.idSeqTemp);
    this.solicitud.unidades = this.solicitud.unidades.filter(unit => unit.id !== row.idSeqTemp);

    this.formatSolicitud(this.solicitud);
  }

}
